var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileWebIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.838,
    height: 17.676,
    viewBox: "0 0 11.838 17.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5890",
    "data-name": "Group 5890",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M13.294,1.008,6.382,1A1.512,1.512,0,0,0,5,2.607V17.069a1.512,1.512,0,0,0,1.382,1.607h6.911a1.512,1.512,0,0,0,1.382-1.607V2.607A1.5,1.5,0,0,0,13.294,1.008Zm0,14.454H6.382V4.214h6.911Z",
    transform: "translate(-1)",
    fill: "#1648c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1410",
    "data-name": "Rectangle 1410",
    width: 6,
    height: 8,
    transform: "translate(9.838 5.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M5,2A3,3,0,1,0,8,5,3,3,0,0,0,5,2ZM7.076,3.8H6.191a4.7,4.7,0,0,0-.414-1.068A2.409,2.409,0,0,1,7.076,3.8ZM5,2.612A4.226,4.226,0,0,1,5.573,3.8H4.427A4.226,4.226,0,0,1,5,2.612ZM2.678,5.6a2.347,2.347,0,0,1,0-1.2H3.692A4.955,4.955,0,0,0,3.65,5a4.955,4.955,0,0,0,.042.6Zm.246.6h.885a4.7,4.7,0,0,0,.414,1.068A2.4,2.4,0,0,1,2.924,6.2Zm.885-2.4H2.924a2.4,2.4,0,0,1,1.3-1.068A4.7,4.7,0,0,0,3.809,3.8ZM5,7.388A4.226,4.226,0,0,1,4.427,6.2H5.573A4.226,4.226,0,0,1,5,7.388ZM5.7,5.6H4.3A4.414,4.414,0,0,1,4.25,5,4.375,4.375,0,0,1,4.3,4.4H5.7A4.376,4.376,0,0,1,5.75,5,4.414,4.414,0,0,1,5.7,5.6Zm.075,1.668A4.7,4.7,0,0,0,6.191,6.2h.885A2.409,2.409,0,0,1,5.777,7.268ZM6.308,5.6A4.955,4.955,0,0,0,6.35,5a4.955,4.955,0,0,0-.042-.6H7.322a2.347,2.347,0,0,1,0,1.2Z",
    transform: "translate(7.838 4.676)",
    fill: "#1648c6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWebIcon);
export default __webpack_public_path__ + "static/media/Mobile_web_icon.9167bef81b496f6140a6b7949b7ddce2.svg";
export { ForwardRef as ReactComponent };